import React from "react";
import "./EquipmentSection.css";

const equipmentData = [
  {
    title: "Control Room",
    image: "/Control-room-optimized.jpg",
    tag: "",
    description:
      "State-of-the-art mixing console and monitoring system for precise audio control and professional mixing capabilities."
  },
  {
    title: "Studio",
    image: "/studiospace.png",
    tag: "",
    description:
      "Acoustically treated live room perfect for vocal recording, instrumental sessions, and ensemble performances."
  },
  {
    title: "SMD Screen",
    image: "/studiospace.png",
    tag: "",
    description:
      "High-resolution display system( 15 x 30 ft) for precise synchronization during film scoring and sound-to-picture sessions."
  },
  {
    title: "Console",
    image: "/console-optimized.jpg",
    tag: "",
    description:
      "Custome made Solid State Logic (SSL-UK Logic Origin 32 channel audio mixer)"
  },
  {
    title: "Instrument",
    image: "/instrument.png",
    tag: "",
    description:
      "Wide array of high quality eastern-classical and western musical instruments, and instrument players"
  },
  {
    title: "Audio Chain and Equipment",
    image: "/audio-optimized.jpg",
    tag: "",
    description:
      "Premium microphones, preamps, and processing equipment ensuring pristine audio capture and manipulation."
  }
];

const EquipmentSection = () => {
  return (
    <section className="section" id="equipment">
      <div className="container">
        <h2 className="section-title">Equipment & Resources</h2>
        <div className="equipment-grid">
          {equipmentData.map((item, index) => (
            <div className="equipment-card" key={index}>
              <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
              <div className="equipment-card-content">
                <span className="equipment-tag">{item.tag}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EquipmentSection;
